<template>
    <admin-page :actions="actions" :fields="fields" :texts="texts"></admin-page>
</template>
<script>

    export default {
        name: 'admin-areas',
        props: [],
        data() {
            return {
                fields: [
                    {
                        key: 'name', label: 'Area name', sortable: true, validations: { required: true, maxLength: 500 },
                        placeholder: 'Enter area name'
                    }
                ],
                actions: {
                    get: 'admin/getAreas',
                    insert: 'admin/insertArea',
                    update: 'admin/updateArea'
                },
                texts: {
                    listTitle: 'Areas',
                    newTitle: 'Add New Area',
                    addButton: 'Add Area',
                    deleteButton: 'Remove',
                    itemName: 'area',
                },
            }
        },
        created() {

        },
        mounted() {
        },
        computed: {


        },
        methods: {


        }
    }
</script>
<style scoped>

</style>
